import * as React from 'react';

export default function PasscodeIcon({ className }: { className?: string }) {
  return (
    <svg width="24" height="24" fill="none" className={className}>
      <rect x="5" y="1" width="14" height="21" rx="1.5" stroke="#fff" />
      <path stroke="#fff" d="M5 17h14" />
      <circle cx="8.625" cy="9.125" r="1.125" fill="#fff" />
      <circle cx="12.125" cy="9.125" r="1.125" fill="#fff" />
      <circle cx="15.625" cy="9.125" r="1.125" fill="#fff" />
    </svg>
  );
}
